import {
  AssignmentKindType,
  AssignmentStatusDetailByClassItem,
} from '../../../../constants/types/lms/assignment/type';
import TextWinds from '../../../common/TextWinds';
import AssignmentStatusStudentRow from './AssignmentStatusStudentRow';

interface AssignmentStatusDetailListProps {
  assignmentKind: AssignmentKindType;
  assignmentTitle: string;
  detailList: AssignmentStatusDetailByClassItem[];
}

/**
 * 개편 LMS (교사) - 과제 관리 > 과제 현황 페이지 > 반별 과제 현황 > 반별 과제 카드 > 학생 과제 목록
 */
const AssignmentStatusDetailList = ({
  assignmentKind,
  assignmentTitle,
  detailList,
}: AssignmentStatusDetailListProps) => {
  if (detailList.length === 0) {
    return (
      <div className="flex h-[80px] items-center justify-center rounded-lg border border-dashed border-gray3 bg-gray0 px-4 text-center">
        <TextWinds type="content_body3" color="gray6">
          학생별 제출 현황이 없습니다.
        </TextWinds>
      </div>
    );
  }

  return (
    <section className="flex flex-col gap-3">
      <div className="flex flex-col overflow-hidden rounded-lg border border-gray2">
        {detailList.map((item) => (
          <AssignmentStatusStudentRow
            key={item.progress.id}
            assignmentKind={assignmentKind}
            assignmentTitle={assignmentTitle}
            detail={item}
          />
        ))}
      </div>
    </section>
  );
};

export default AssignmentStatusDetailList;
